import React from "react"
import {  Link } from "gatsby"
import styles from "./index.module.css";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import  BlogPlaceholder  from "../../gatsby-images/blog-placeholder";
import Pagination from "react-js-pagination";
import Img from 'gatsby-image'
import { formatDate } from "../../common/gFunctions";
import ReactHtmlParser from 'react-html-parser';

const { getBlogPath } = require('../../gFunctions')

class Blog extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
      modal: false
    };
     
    this.listTopRef = React.createRef() 
   
  }

  scrollTolistTopRef = () => {
    setTimeout(()=>{
      window.scrollTo({ behavior: 'smooth', top: this.listTopRef.current.offsetTop });

    },5);
  }   

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  toggleModal = () => {
    this.setState(prevState => ({
      modal: !this.state.modal
    }));
  }
  
  viewTags = () => {
    this.setState({ modal: true});
  }

  componentDidMount()
  {

    if (this.props.location && this.props.location.state && this.props.location.state.scroll) {
      this.scrollTolistTopRef();
    }
  }

  render() {
    const {index, numPages, tags, posts, perPage, location={}, title='Blog'} = this.props;

    return (
      <>
        <div className={[styles.blog_main_section,'blog_main_section'].join(' ')}>
          <div className={[styles.top_banner_section].join(' ')} >
              <div className="container">
                <div className="row">
                    <div className={[styles.mpr_main_title,'d-flex', 'offset-xl-1'].join(' ')}>
                        <div className={["align-self-end", "mb-5", "pb-5"].join(" ")}>
                            <div className="align-self-stretch">
                              <h2>{title}</h2>
                            </div>
                        </div>
                    </div>
                  </div>
              </div>
             
          </div>
          <div className={styles.mpr_blog_list_section} ref={this.listTopRef}>
            <div className="container">
              <div className={["row", "justify-content-between"].join(" ")}>
                <div className={["col-xl-2", "col-lg-3", "order-lg-2", "pl-0 pr-0"].join(" ")}>
                  <div className={styles.blog_sidebar}>
                    <div>
                      <div  className={["pl-lg-0", "pl-5", "pr-lg-0", "pr-5", "pt-4", "pb-4", "pt-lg-0", "pb-lg-0"].join(" ")}>
                        <div className={["d-lg-block", "d-none"].join(" ")}>
                          <h6>Popular Tags</h6>
                          {
                            tags.map(({ node },index) => (
                              <div key={node.id}><Link to={getBlogPath(node.path)}>
                                <p>{ReactHtmlParser(node.name)}</p>
                              </Link></div>
                            ))
                          }
                        </div>
                        <div className={["d-lg-none", "d-flex", "justify-content-start", "pt-3", "pb-3"].join(" ")}>
                          <button className={["btn", "btn-primary", "btn-sm"].join(" ")} onClick={this.viewTags}>Tags</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                

                <div className={["col-xl-8", "col-lg-8", "order-lg-1", "pl-lg-0", "pl-5", "pr-lg-0", "pr-5", "offset-xl-1"].join(" ")} >
                {

                  posts.map(({ node }) => (
                    <div className={[styles.blog_list,'pb-md-5', 'mb-md-5', 'mb-4', 'pb-4'].join(' ')} key={node.slug}>
                      <div className="row">
                        <div className={["col-md-3", "col-12", "text-center", "mb-3"].join(" ")}>
                          {
                            node.featured_media && node.featured_media.localFile && node.featured_media.localFile && node.featured_media.localFile.childImageSharp
                            ?
                            <Img fluid={node.featured_media.localFile.childImageSharp.fluid} />
                            :
                            <BlogPlaceholder/>
                          }
                        </div>
                        <div className={["col-md-9", "col-12"].join(" ")}>
                          <h5 className={[styles.blog_title,'mb-2'].join(' ')}> <Link to={getBlogPath(node.path)} crossOrigin="anonymous" state={{backLink:location.pathname}}>
                            <div>{ReactHtmlParser(node.title)}</div>
                          </Link></h5>
                          <div className="blog_text d-none d-md-block">
                            <div>
                              {ReactHtmlParser(node.excerpt)}
                            </div>
                          </div>
                          <div className={styles.author}>
                            {formatDate(node.date)}
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  ))
                }
                {
                  this.props.showPagination &&
                  <div className="container ">
                    <div className={["col-md-12", "text-center"].join(" ")}>
                      <nav aria-label="Page navigation" className={["col", "mt-md-5", "mt-2", "d-md-block", "d-none"].join(" ")}>
                      
                          <Pagination
                          hideDisabled
                          activePage={index}
                          itemsCountPerPage={perPage}
                          totalItemsCount={ perPage * numPages}
                          pageRangeDisplayed={10}
                          itemClass="page-item"
                          linkClass="page-link"
                          innerClass="justify-content-center pagination"
                          onChange={this.props.handlePageChange}
                        />

                      </nav>
                      <nav aria-label="Page navigation" className={["col", "mt-md-5", "mt-2", "d-md-none", "d-block"].join(" ")}>
                      
                          <Pagination
                          hideDisabled
                          activePage={index}
                          itemsCountPerPage={perPage}
                          totalItemsCount={ perPage * numPages}
                          pageRangeDisplayed={5}
                          itemClass="page-item"
                          linkClass="page-link"
                          innerClass="justify-content-center pagination"
                          onChange={this.props.handlePageChange}
                        />

                      </nav>

                    </div>
                  </div>
                }
                </div>
              </div>
            </div>
          </div>
         
            <Modal isOpen={this.state.modal} toggle={this.toggleModal} className={[this.props.className, "tag-modal"].join(" ")}>
                <ModalHeader className={styles.modal_header} toggle={this.toggleModal}>Popular Tags</ModalHeader>
                <ModalBody>
                {
                  tags.map(({ node }) => (
                    <div className="modal_item" key={node.id}><Link to={getBlogPath(node.path)}>
                      <p>{ReactHtmlParser(node.name)}</p>
                    </Link></div>
                  ))
                }
                </ModalBody>
            </Modal>
          
        </div>
      </>
    );
  }
}

export default Blog
